<template>
    <div>
        <h2 class="text-primary fw-bolder text-center my-3">Notes</h2>
        <UserCreate />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />
        <UserList />

    </div>
</template>

<script>
    import UserCreate from "../components/UserCreate";
    import UserList from "../components/UserList";
    export default {
      components: {UserList, UserCreate}
    }
</script>

<style scoped>

</style>